import Icon from './Icon.jsx'

const ErrorIcon = () => {
    return <span>
        <Icon icon="warning-triangle" color="red" height={16} width={16} />&nbsp;Error
    </span>
}
export default ErrorIcon